// extracted by mini-css-extract-plugin
export default {"colorpicker":"BorderProperty_colorpicker__w6hA-","select":"BorderProperty_select__79HCn"};